import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CheckoutError.css';

function CheckoutError() {
  const navigate = useNavigate();
  const location = useLocation();
  const { error, planName } = location.state || {};

  const getErrorMessage = (errorText) => {
    // User-friendly error messages
    const errorMap = {
      'PayPal ist nicht aktiviert': 'Momentan sind Online-Zahlungen nicht verfügbar. Bitte versuche es später erneut oder wähle Banküberweisung.',
      'Fehler beim Erstellen der Zahlung': 'Die Zahlung konnte nicht verarbeitet werden. Bitte überprüfe deine Eingaben.',
      'PayPal-Zahlung fehlgeschlagen': 'Die PayPal-Zahlung wurde abgebrochen oder ist fehlgeschlagen.',
      'Kreditkarten-Zahlung fehlgeschlagen': 'Die Kreditkartenzahlung wurde abgelehnt. Bitte überprüfe deine Kartendaten.'
    };

    return errorMap[errorText] || errorText || 'Ein unerwarteter Fehler ist aufgetreten.';
  };

  const getSupportOptions = () => {
    return [
      {
        icon: '💳',
        title: 'Alternative Zahlungsmethode',
        description: 'Versuche eine andere Zahlungsmethode',
        action: () => navigate('/pricing')
      },
      {
        icon: '📧',
        title: 'E-Mail Support',
        description: 'support@zenta.me',
        action: () => window.location.href = 'mailto:support@zenta.me?subject=Zahlungsproblem'
      },
      {
        icon: '💬',
        title: 'Live-Chat',
        description: 'Chatte mit unserem Support-Team',
        action: () => {/* Could integrate live chat */}
      }
    ];
  };

  return (
    <div className="checkout-error-page" data-testid="checkout-error-page">
      <div className="error-container">
        <div className="error-icon">❌</div>
        <h1 className="error-title">Zahlung fehlgeschlagen</h1>
        <p className="error-message">
          {getErrorMessage(error)}
        </p>

        {planName && (
          <div className="error-details">
            <p>Versuchter Plan: <strong>{planName}</strong></p>
          </div>
        )}

        <div className="help-section">
          <h2>Wie können wir helfen?</h2>
          <div className="support-options">
            {getSupportOptions().map((option, index) => (
              <div 
                key={index}
                className="support-option-card"
                onClick={option.action}
                data-testid={`support-option-${index}`}
              >
                <div className="support-icon">{option.icon}</div>
                <h3>{option.title}</h3>
                <p>{option.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="error-actions">
          <button 
            onClick={() => navigate('/pricing')} 
            className="btn-primary"
            data-testid="try-again-button"
          >
            Erneut versuchen
          </button>
          <button 
            onClick={() => navigate('/dashboard')} 
            className="btn-secondary"
            data-testid="go-to-dashboard-button"
          >
            Zum Dashboard
          </button>
        </div>

        <div className="faq-section">
          <h3>Häufige Probleme</h3>
          <div className="faq-list">
            <div className="faq-item">
              <strong>Kreditkarte abgelehnt?</strong>
              <p>Überprüfe das Kartenlimit und ob genug Guthaben vorhanden ist.</p>
            </div>
            <div className="faq-item">
              <strong>PayPal-Fehler?</strong>
              <p>Stelle sicher, dass dein PayPal-Konto verifiziert und aktiv ist.</p>
            </div>
            <div className="faq-item">
              <strong>Technisches Problem?</strong>
              <p>Versuche es mit einem anderen Browser oder Gerät.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CheckoutError;